// Runtime config helper.
// At build time, process.env.REACT_APP_* vars are baked into the bundle.
// At runtime, public/config.js sets window.__env__ so a server can inject
// real values without a rebuild (useful for Docker / CI deployments).
// This module tries window.__env__ first and falls back to process.env.
const _env = (typeof window !== "undefined" && window.__env__) || {};

const get = (key) => _env[key] || process.env[key];

const config = {
  apiUrl: get("REACT_APP_BACKEND_WEBSERVICES"),
  phpApiUrl: get("REACT_APP_PHP_BACKEND_WEBSERVICES"),
  newsApiUrl: get("REACT_APP_NEWS_API_URL"),
  newsApiKey: get("REACT_APP_NEWS_API_KEY"),
  encryptionKey: get("REACT_APP_ENCRYPTION_KEY"),
  recaptchaSiteKey: get("REACT_APP_RECAPTCHA_API_KEY"),
  signupRedirectErrorUrl: get("REACT_APP_SIGNUP_REDIRECT_ERROR_URL"),
  serverUserSignupPayload2Name: get("REACT_APP_SERVER_USER_SIGNUP_FINISHED_PAYLOAD2_NAME"),
  serverUserLoginPayload3Name: get("REACT_APP_SERVER_USER_LOGIN_FINISHED_PAYLOAD3_NAME"),
};

export default config;



// WEBPACK FOOTER //
// ./src/config.js